<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ "repository.categories.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button
        *ngIf="!isCreationMode"
        (click)="onEdit()"
        [matTooltip]="'repository.transportTypes.list.add' | translate"
        mat-mini-fab
        class="action-button"
        color="primary"
      >
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-transport-type-edit
        *ngIf="isCreationMode && !editedId"
        [transportTypes]="transportTypes"
        [urgencyLevels]="urgencyLevels"
        (editFinished)="onEditFinished()"
      ></app-transport-type-edit>
    </section>
    <section class="datatable-container">
      <div>
        <h3>Type de produit</h3>
        <mat-form-field class="filterField">
          <mat-label>Filtrer</mat-label>
          <input
            matInput
            (keyup)="applyFilterTransportType($event)"
            placeholder="Votre filtre"
            #input
          />
        </mat-form-field>

        <table
          mat-table
          [dataSource]="dataSourceTransportType"
          multiTemplateDataRows
          matSort
          #TransportTypesSort="matSort"
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.transportTypes.list.name" | translate }}
            </th>
            <td mat-cell *matCellDef="let transportType">
              {{ transportType.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dictionary">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Catégorie</th>
            <td mat-cell *matCellDef="let transportType">
              {{ transportType.dictionary.description }}
            </td>
          </ng-container>

          <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.transportTypes.list.client" | translate }}
            </th>
            <td mat-cell *matCellDef="let transportType">
              {{ transportType.client?.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="site">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.transportTypes.list.site" | translate }}
            </th>
            <td mat-cell *matCellDef="let transportType">
              <ul>
                <li *ngFor="let site of transportType.sites">
                  {{ site.name }}
                </li>
              </ul>
            </td>
          </ng-container>

          <ng-container matColumnDef="temperature">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Température
            </th>
            <td mat-cell *matCellDef="let transportType">
              <span *ngIf="transportType.temperature !== null && transportType.temperature !== undefined">{{ transportType.temperature | signedTemperature }}°</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              {{ "repository.transportTypes.list.actions" | translate }}
            </th>
            <td mat-cell *matCellDef="let transportType">
              <ng-container *ngIf="transportType.id !== editedId">
                <button
                  mat-icon-button
                  class="action-button"
                  color="primary"
                  [disabled]="isLoading"
                  [matTooltip]="
                    'repository.transportTypes.list.edit' | translate
                  "
                  (click)="onEdit(transportType.id)"
                >
                  <mat-icon aria-label="Edit">edit</mat-icon>
                </button>
              </ng-container>
              <ng-container>
                <button
                  mat-icon-button
                  class="action-button"
                  color="primary"
                  [disabled]="isLoading"
                  [matTooltip]="
                    'repository.transportTypes.list.delete' | translate
                  "
                  (click)="deleteTypeTransport(transportType.id)"
                >
                  <mat-icon aria-label="Delete">clear</mat-icon>
                </button>
              </ng-container>
            </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let transportType"
              [attr.colspan]="displayedColumnsTransport.length"
            >
              <div
                *ngIf="transportType.id === editedId"
                class="row-edit"
                [@detailExpand]="
                  transportType.id === editedId ? 'expanded' : 'collapsed'
                "
              >
                <app-transport-type-edit
                  [dictionaryValue]="transportType"
                  [transportTypes]="transportTypes"
                  [urgencyLevels]="urgencyLevels"
                  (editFinished)="onEditFinished()"
                ></app-transport-type-edit>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsTransport"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsTransport"
            class="row"
            [ngClass]="{ 'expanded-row': row.id === editedId }"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="detail-row"
          ></tr>
        </table>
        <mat-paginator
          class="paginator"
          [pageSizeOptions]="[20, 25, 50, 100]"
          showFirstLastButtons
          #TransportTypesPaginator
        ></mat-paginator>
      </div>

      <div>
        <h3>Niveau d'urgence</h3>
        <mat-form-field class="filterField">
          <mat-label>Filtrer</mat-label>
          <input
            matInput
            (keyup)="applyFilterUrgencyLevel($event)"
            placeholder="Votre filtre"
            #input
          />
        </mat-form-field>

        <table
          mat-table
          [dataSource]="dataSourceUrgencyLevel"
          multiTemplateDataRows
          matSort
          #UrgencyLevelsSort="matSort"
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.urgencyLevels.list.name" | translate }}
            </th>
            <td mat-cell *matCellDef="let urgencyLevel">
              {{ urgencyLevel.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dictionary">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Catégorie</th>
            <td mat-cell *matCellDef="let urgencyLevel">
              {{ urgencyLevel.dictionary.description }}
            </td>
          </ng-container>

          <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.urgencyLevels.list.client" | translate }}
            </th>
            <td mat-cell *matCellDef="let urgencyLevel">
              {{ urgencyLevel.client?.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="site">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.urgencyLevels.list.site" | translate }}
            </th>
            <td mat-cell *matCellDef="let urgencyLevel">
              <ul>
                <li *ngFor="let site of urgencyLevel.sites">{{ site.name }}</li>
              </ul>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              {{ "repository.urgencyLevels.list.actions" | translate }}
            </th>
            <td mat-cell *matCellDef="let urgencyLevel">
              <ng-container *ngIf="urgencyLevel.id !== editedId">
                <button
                  mat-icon-button
                  class="action-button"
                  color="primary"
                  [disabled]="isLoading"
                  [matTooltip]="
                    'repository.urgencyLevels.list.edit' | translate
                  "
                  (click)="onEdit(urgencyLevel.id)"
                >
                  <mat-icon aria-label="Edit">edit</mat-icon>
                </button>
              </ng-container>
              <ng-container>
                <button
                  mat-icon-button
                  class="action-button"
                  color="primary"
                  [disabled]="isLoading"
                  [matTooltip]="
                    'repository.urgencyLevels.list.delete' | translate
                  "
                  (click)="deleteUrgencyLevel(urgencyLevel.id)"
                >
                  <mat-icon aria-label="Delete">clear</mat-icon>
                </button>
              </ng-container>
            </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let urgencyLevel"
              [attr.colspan]="displayedColumnsUrgency.length"
            >
              <div
                *ngIf="urgencyLevel.id === editedId"
                class="row-edit"
                [@detailExpand]="
                  urgencyLevel.id === editedId ? 'expanded' : 'collapsed'
                "
              >
                <app-transport-type-edit
                  [dictionaryValue]="urgencyLevel"
                  [transportTypes]="transportTypes"
                  [urgencyLevels]="urgencyLevels"
                  (editFinished)="onEditFinished()"
                ></app-transport-type-edit>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsUrgency"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsUrgency"
            class="row"
            [ngClass]="{ 'expanded-row': row.id === editedId }"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="detail-row"
          ></tr>
        </table>
        <mat-paginator
          class="paginator"
          [pageSizeOptions]="[20, 25, 50, 100]"
          showFirstLastButtons
          #UrgencyLevelsPaginator
        ></mat-paginator>
      </div>
    </section>
    <mat-progress-bar
      *ngIf="isLoading"
      class="progress-bar"
      mode="indeterminate"
      color="primary"
    ></mat-progress-bar>
  </mat-card-content>
</mat-card>
